import { useSelector } from 'react-redux';
import { selectTerms, selectShowTranslationsKeys } from '../redux/appSlice';

export default function useTranslation() {
  const terms = useSelector(selectTerms);
  const showKeys = useSelector(selectShowTranslationsKeys)
  return (key:string) => {

    if(showKeys) {
      return key;
    }

    if(Object.keys(terms).length < 1) {
      return "░".repeat(8)
    }
    return terms[key] || key
  };
}